import { hasPlan } from '../guards/checkout'
import buildMeta from '../utils/buildMeta'

const routes = [
  {
    name: 'plan',
    path: '/plan',
    component: () => import('@/pages/Plans/ConsumerPlans.vue'),
    meta: buildMeta({
      authRequired: false,
      hideDistractions: true,
      liveChatEnabled: true,
      robots: null,
      title: 'Choose your plan - Jobscan',
      description:
        'Compare pricing plans to get powerful tools to improve your resume. Get started free. Get more interviews.',
    }),
  },
  {
    name: 'coachplan',
    path: '/plan/coach',
    component: () => import('@/pages/Plans/CoachLite.vue'),
    meta: buildMeta({
      authRequired: false,
      hideDistractions: true,
      liveChatEnabled: true,
      robots: null,
      title: 'Choose your Coach plan - Jobscan',
      description: 'Powerful tools to help your clients get more interviews.',
    }),
  },
  {
    name: 'checkout',
    path: '/plan/checkout',
    component: () => import('@/pages/PlansCheckout/PlansCheckout.vue'),
    beforeEnter: [hasPlan],
    meta: buildMeta({
      authRequired: true,
      hideDistractions: true,
      liveChatEnabled: true,
      title: 'Upgrade now - Jobscan',
      description:
        'Get professional guidance to Create Resumes and Cover Letters.',
    }),
  },
  {
    name: 'checkout-confirmation',
    path: '/plan/checkout/confirmation',
    component: () =>
      import('@/pages/CheckoutConfirmation/CheckoutConfirmation.vue'),
    meta: buildMeta({
      authRequired: true,
      hideDistractions: true,
      liveChatEnabled: true,
      title: 'Start Scanning - Jobscan',
      description: 'Start optimizing your resume for your next job.',
    }),
  },
  {
    name: 'promo',
    path: '/plan/promo/:promoId?',
    component: () => import('@/pages/Plans/ConsumerPlans.vue'),
    meta: buildMeta({
      authRequired: false,
      hideDistractions: true,
      liveChatEnabled: true,
    }),
  },
  {
    name: 'fast-checkout',
    path: '/plan/fast-checkout',
    component: () =>
      import('@/pages/PlansCheckout/InterstitialPlanSelector.vue'),
    meta: buildMeta({
      authRequired: true,
      hideDistractions: true,
    }),
  },
]

export default routes
